import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { NumberField } from '~admin/view/components/ui/form/fields/field-number.component';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

interface Props {
  name: string;
}

export interface FixPaymentDetailsFormData {
  minManualPaymentDurationMinutes?: number;
  maxManualPaymentDurationMinutes?: number;
}

export const FixPaymentTimeDetails: React.FunctionComponent<Props> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Row>
        <RestrictBox>
          <NumberField
            name={`${name}.minManualPaymentDurationMinutes`}
            label={t('createEvent.marketplaceDetails.dateTime.minManualPaymentDurationMinutes')}
            shrink
          />
        </RestrictBox>
        <RestrictBox>
          <NumberField
            name={`${name}.maxManualPaymentDurationMinutes`}
            label={t('createEvent.marketplaceDetails.dateTime.maxManualPaymentDurationMinutes')}
            shrink
          />
        </RestrictBox>
      </Row>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const Row = styled(Box)`
  margin-top: 12px;
  > div:not(:first-child) {
    margin-left: 50px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin: 0 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/marketplace-details/marketplace-datetime-details/fix-payment-time-details.component.tsx